import { motion } from 'framer-motion';
import { useAuthStore } from '@/lib/auth';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Input } from '@/components/ui/input';
import { Label } from '@/components/ui/label';
import { Button } from '@/components/ui/button';
import { Separator } from '@/components/ui/separator';
import { User, Key, Bell, Palette } from 'lucide-react';

export default function SettingsPage() {
  const { user } = useAuthStore();

  return (
    <div className="p-4 sm:p-6 md:p-8 max-w-[800px] mx-auto">
      <h1 className="text-xl sm:text-2xl font-bold tracking-tight mb-4 sm:mb-6" style={{ fontFamily: 'Space Grotesk' }}>Settings</h1>

      <div className="space-y-6">
        {/* Profile */}
        <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }}>
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2 text-base" style={{ fontFamily: 'Space Grotesk' }}>
                <User className="w-4 h-4" /> Profile
              </CardTitle>
            </CardHeader>
            <CardContent className="space-y-4">
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
                <div className="space-y-2">
                  <Label>Name</Label>
                  <Input defaultValue={user?.name || ''} className="h-11 rounded-xl" />
                </div>
                <div className="space-y-2">
                  <Label>Email</Label>
                  <Input defaultValue={user?.email || ''} disabled className="h-11 rounded-xl" />
                </div>
              </div>
              <div className="flex items-center gap-3">
                <span className="text-xs text-muted-foreground">Role: <span className="font-mono text-foreground capitalize">{user?.role}</span></span>
                <span className="text-xs text-muted-foreground">Plan: <span className="font-mono text-primary uppercase">{user?.plan}</span></span>
              </div>
              <Button className="rounded-full h-10 px-5 text-sm" disabled>Save Changes</Button>
            </CardContent>
          </Card>
        </motion.div>

        {/* API Keys */}
        <motion.div initial={{ opacity: 0, y: 12 }} animate={{ opacity: 1, y: 0 }} transition={{ delay: 0.1 }}>
          <Card>
            <CardHeader>
              <CardTitle className="flex items-center gap-2 text-base" style={{ fontFamily: 'Space Grotesk' }}>
                <Key className="w-4 h-4" /> API Keys
              </CardTitle>
            </CardHeader>
            <CardContent>
              <p className="text-sm text-muted-foreground">Bring your own LLM API keys for enhanced analysis capabilities.</p>
              <div className="mt-4 space-y-3">
                <div className="space-y-2">
                  <Label>Anthropic API Key</Label>
                  <Input type="password" placeholder="sk-ant-..." className="h-11 rounded-xl font-mono" />
                </div>
                <div className="space-y-2">
                  <Label>OpenAI API Key</Label>
                  <Input type="password" placeholder="sk-..." className="h-11 rounded-xl font-mono" />
                </div>
              </div>
              <Button className="rounded-full h-10 px-5 text-sm mt-4" disabled>Save Keys</Button>
            </CardContent>
          </Card>
        </motion.div>
      </div>
    </div>
  );
}
